import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { StyledGrid } from 'styles/common';

import NoFeedback from 'assets/assetsV1/illustrations/newIllustrations/noFeedback.svg';
import CurvedArrow from 'assets/images/curved-arrow.svg?react';

import { SENTIMENTS_TYPES } from 'constants/ProjectConstants';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledImageContainer = styled.div`
  width: 33%;
`;

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  aspect-ratio: 3 / 2;
`;

const ArrowIconContainer = styled.div`
  svg {
    fill: ${(props) => props.theme.palette.borders.lightGrey};
    width: 100%;
    height: auto;
  }
  position: absolute;
  top: -40px;
  right: ${(props) => (props.$isShareBtn ? '100px' : '110px')};
  width: 50px;
  transform: scaleY(-1) rotate(125deg);
  ${(props) => props.theme.breakpoints.down('xs')} {
    display: none;
  }
`;

const Header = ({ showShareFeedbackButton = true, hideShareFeedbackButtons = false }) =>
  !hideShareFeedbackButtons && (
    <ArrowIconContainer $isShareBtn={showShareFeedbackButton}>
      <CurvedArrow />
    </ArrowIconContainer>
  );

const NoFeedbacksMessage = ({
  employeeId,
  feedbackType = SENTIMENTS_TYPES.appreciative.value,
  isCompetencySidePanel = false,
  accessible = false,
  competencyId,
  hideShareFeedbackButtons = false,
}) => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId, shallowEqual);

  const showShareFeedbackButton = loggedInEmployeeId !== employeeId;

  return (
    <StyledGrid
      style={{ position: 'relative' }}
      container
      justify="center"
      alignItems="center"
      direction="column"
      topGutter={6}
    >
      <Header
        employeeId={employeeId}
        feedbackType={feedbackType}
        showShareFeedbackButton={showShareFeedbackButton}
        showRequestFeedbackButton={isCompetencySidePanel ? accessible : true}
        competencyId={competencyId}
        hideShareFeedbackButtons={hideShareFeedbackButtons}
      />
      <StyledImageContainer>
        <StyledImg alt="no-feedback-image" src={NoFeedback} />
      </StyledImageContainer>
      <TextBodyMedium bold mt={3}>
        Nothing to see here yet.
      </TextBodyMedium>
      <TextBodyMedium textAlign="center" mt={1} mb={4} color="text.g2">
        Nothing to see here yet. Request feedback for better performance enablement!
      </TextBodyMedium>
    </StyledGrid>
  );
};

export default NoFeedbacksMessage;
